import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'ui/videoCallEndPopup';

export const VIDEO_CALL_END_POPUP = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const videoCallEndPopupActions = {
  open: createAction(VIDEO_CALL_END_POPUP.OPEN),
  close: createAction(VIDEO_CALL_END_POPUP.CLOSE),
};

const initialState = {
  visible: false,
  status: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case VIDEO_CALL_END_POPUP.OPEN: {
      return {
        visible: true,
        status: payload,
      };
    }

    case VIDEO_CALL_END_POPUP.CLOSE: {
      return {
        ...state,
        visible: false,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/videoCallEndPopup.js